import { jsx as n, jsxs as d } from "react/jsx-runtime";
import { createContext as D, useEffect as O, useContext as I } from "react";
import { drawerBlueprint as N } from "./index-blueprint.es.js";
import { Drawer as r } from "vaul";
import w from "clsx";
import { useOverlayState as g } from "@made-people/blueprint-overlay";
import { Heading as b } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const x = D({
  hasOverlay: !0,
  hasHandle: !0,
  direction: "bottom"
}), t = ({
  variants: m,
  hasOverlay: l = !0,
  hasHandle: o = !0,
  hasScaledBackground: u = !0,
  setBackgroundColorOnScale: i = !1,
  children: h,
  direction: c = "bottom",
  header: f,
  ...e
}) => {
  const a = g(e.customOverlayId), s = a.isOpen ?? e.open;
  return O(() => {
    e.defaultOpen && a.onChange(!0);
  }, []), O(() => {
    var C;
    typeof s == "boolean" && ((C = e.onOpenChange) == null || C.call(e, s));
  }, [s, e.onOpenChange]), /* @__PURE__ */ n(
    x.Provider,
    {
      value: { direction: c, variants: m, hasOverlay: l, hasHandle: o, header: f },
      children: /* @__PURE__ */ n(
        r.Root,
        {
          ...e,
          open: s,
          onOpenChange: a.onChange,
          shouldScaleBackground: u,
          setBackgroundColorOnScale: i,
          direction: c,
          children: h
        }
      )
    }
  );
};
function v({
  children: m,
  overlaySettings: l,
  contentSettings: o,
  portalSettings: u
}) {
  const { variants: i, hasOverlay: h, hasHandle: c, direction: f, header: e } = I(x), a = N.styles({
    ...i,
    direction: (i == null ? void 0 : i.direction) ?? f
  });
  return /* @__PURE__ */ d(r.Portal, { ...u, children: [
    h && /* @__PURE__ */ n(
      r.Overlay,
      {
        ...l,
        className: w(a.overlay, l == null ? void 0 : l.className)
      }
    ),
    /* @__PURE__ */ n(r.Title, { hidden: !0, children: "Drawer" }),
    /* @__PURE__ */ d(r.Description, { hidden: !0, children: [
      " ",
      (o == null ? void 0 : o["aria-description"]) ?? "Drawer"
    ] }),
    /* @__PURE__ */ d(
      r.Content,
      {
        "aria-description": "Content for drawer",
        tabIndex: -1,
        ...o,
        className: w(
          a.content,
          "focus:outline-none",
          o == null ? void 0 : o.className
        ),
        children: [
          c && /* @__PURE__ */ n("div", { className: a.dragHandle }),
          e != null && e.headingSettings && (e != null && e.headingSettings.badge || e.headingSettings.heading) ? /* @__PURE__ */ d("div", { className: a.header, children: [
            /* @__PURE__ */ n(b, { ...e.headingSettings }),
            e.closeIcon && /* @__PURE__ */ n(r.Close, { className: a.headerCloseIcon, children: e.closeIcon })
          ] }) : (e == null ? void 0 : e.closeIcon) && /* @__PURE__ */ n(r.Close, { className: a.closeIcon, children: e.closeIcon }),
          m
        ]
      }
    )
  ] });
}
t.Trigger = r.Trigger;
t.Close = r.Close;
t.Title = r.Title;
t.Content = v;
export {
  t as Drawer
};
//# sourceMappingURL=index.es.js.map
